import {
  getWhatsNewDialog,
  getWhatsNewArticle,
  recordWhatsNewDialogViewQgl,
} from '../../../shared/whatIsNew';

/**
 * @param {string} product
 * @param {string} token
 */
export const isWhatsNewDialogAvailable = async (product, token) => {
  return getWhatsNewDialog(product, token);
};

/**
 * @param {string} product
 * @param {string} token
 */
export const whatsNewArticle = async (product, token) => {
  return getWhatsNewArticle(product, token);
};

/**
 * @param {string} dialogId
 * @param {string} token
 */
export const recordWhatsNewDialogView = async (dialogId, token) => {
  return recordWhatsNewDialogViewQgl(dialogId, token);
};
